import React from "react";
import { useDispatch } from "react-redux";
import { add, remove } from "../../store/actions/loader";

export default React.memo(() => {
  const dispatch = useDispatch();

  React.useEffect(() => {
    const action = add();
    dispatch(action);
    return () => {
      dispatch(remove(action.payload.processId));
    };
  }, [dispatch]);

  return null;
});
